module.exports = __webpack_public_path__ + "labioplastika_7_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/labioplastika_7_after.jpg
// module id = 1079
// module chunks = 0